import { QuotaModel } from "../QuotaModel";
import { QuotaStatus } from "../enums/QuotaStatus";

export function createQuota(el?: any): QuotaModel {
    if (el == null) return undefined;
    return {
        id: el.id,
        stratumId: el.stratumId,
        condition: el.condition,
        description: el.description,
        variables: el.variables,
        status: QuotaStatus[el.status as string] || QuotaStatus.Open,
        userStatus: QuotaStatus[el.userStatus as string] || QuotaStatus.Open,
        todo: el.todo,
        objective: el.objective,
        frequency: el.frequency,
        online: el.online,
        userObjective: el.userObjective,
        userFrequency: el.userFrequency,
    };
}
